<template>
  <div class="about">
    <h1>Page not Found</h1>
  </div>
</template>
